// TODO use consistently.
export const PAY_PAL_TITLE = `PayPal`

// Payment images
export const PAY_PAL_LOGO           = `/images/payment/pay-pal.svg`
export const PAY_PAL_WHITE_LOGO     = `/images/payment/pay-pal-white.svg`
export const STRIPE_LOGO            = `/images/payment/stripe.svg`
export const STRIPE_WHITE_LOGO      = `/images/payment/stripe-white.svg`
export const JUSTGIVING_LOGO        = `/images/payment/justgiving-logo.svg`
export const SECURE_LOGO            = `/images/payment/secure-logo.svg`
export const VERISIGN_SECURED_LOGO  = `/images/payment/verisign-secured.svg`
export const MCAFEE_SECURE_LOGO     = `/images/payment/mcafee-secure.svg`
export const SECURE_SYSTEMS         = [
  {
    title: `Secure`,
    img: SECURE_LOGO,
  },
  {
    title: `Verisign Secured`,
    img: VERISIGN_SECURED_LOGO,
  },
  {
    title: `Mcafee Secure`,
    img: MCAFEE_SECURE_LOGO,
  },
]
// TODO: If unused and won't use in the future -> remove
export const CVC_VISA_MASTER_CARD_DISCOVER  = `/images/payment/visa.png`
export const CVC_AMERICAN_EXPRESS           = `/images/payment/amex.png`

export const VISA_LOGO        = `/images/payment/visa.svg`
export const MASTER_CARD_LOGO = `/images/payment/mastercard.svg`
export const AMEX_LOGO        = `/images/payment/amex.svg`
export const UNION_PAY_LOGO   = `/images/payment/union-pay.svg`
export const JCB_LOGO         = `/images/payment/jcb.svg`
export const DISCOVER_LOGO    = `/images/payment/discover.svg`
export const PAYMENT_SYSTEMS  = [
  {
    title: `Visa`,
    img: VISA_LOGO,
  },
  {
    title: `Master Card`,
    img: MASTER_CARD_LOGO,
  },
  {
    title: `Amex`,
    img: AMEX_LOGO,
  },
  {
    title: `Union Pay`,
    img: UNION_PAY_LOGO,
  },
  {
    title: `Jcb`,
    img: JCB_LOGO,
  },
  {
    title: `Discover`,
    img: DISCOVER_LOGO,
  },
  {
    title: `PayPal`,
    img: PAY_PAL_LOGO,
  },
]
